// App.js
import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import StudentPage from './pages/StudentPage';
import ParentPage from './pages/ParentPage';

function App() {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tabValue} onChange={handleChange} centered>
        <Tab label="Học sinh" />
        <Tab label="Phụ huynh" />
      </Tabs>
      <Box sx={{ paddingTop: '20px' }}>
        {tabValue === 0 && <StudentPage />}
        {tabValue === 1 && <ParentPage />}
      </Box>
    </Box>
  );
}

export default App;
